module.exports = __webpack_public_path__ + "static/media/19-9.35e6f8ad.mp3";